
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {SalidaService} from "@/services/SalidaService";
import {ingresoStore} from "@/store/ingresoStore";
import {salidaStore} from "@/store/salidaStore";

import * as stream from "stream";
import {UserAuth} from "@/models/UserAuth";

@Component({
  name: "salidaEdit",
  computed: {
    UserAuth() {
      return UserAuth
    }
  },
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }
  @Prop() salidaoEdit!: any
  @Prop() isNew!: boolean
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private ingresoStore = ingresoStore();
  private salidaStore = salidaStore();
  private materialService = MaterialService.getInstance();
  private ingresolService = IngresoService.getInstance();
  private salidaService = SalidaService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  txtBuscar = '';
  cantidad= 1;
  cantidad_entregada= 1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  selected_funcionario = null;
  txtFuncionario = "";
  historialVisible = false;


  salida = {
    id: this.$route.params.salidaEdit.id,
    codigo: this.$route.params.salidaEdit.codigo,
    numero_almacen: this.$route.params.salidaEdit.numero_almacen,
    tipo: this.$route.params.salidaEdit.tipo,
    tipo_instalacion: this.$route.params.salidaEdit.tipo_instalacion,
    fecha_despacho: this.$route.params.salidaEdit.fecha_despacho,
    recibe_material_funcionario_id: this.$route.params.salidaEdit.recibe_material_funcionario_id,
    autoriza_material_funcionario_id: this.$route.params.salidaEdit.autoriza_material_funcionario_id,
    es_despachado: this.$route.params.salidaEdit.es_despachado,
    estado: this.$route.params.salidaEdit.estado,
    medidor_id: this.$route.params.salidaEdit.medidor_id,
    serie: this.$route.params.salidaEdit.serie,
    lectura: this.$route.params.salidaEdit.lectura,
    centro_costos: this.$route.params.salidaEdit.centro_costos,
    verificado_kardex: this.$route.params.salidaEdit.verificado_kardex,
    numero_vale: this.$route.params.salidaEdit.numero_vale,
    numero_comprobante: this.$route.params.salidaEdit.numero_comprobante
  };
  clientes = [];
  materiales = [];
  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };


  public medidor= {
    id: '',
    serie: ''
  };

  mounted(){
    this.getFuncionarioResponsable();
    this.getFuncionarioResponsableAutoriza();
    this.getTipo();
    this.showMaterialesSalida();
    this.getHistoriaL();
    this.getCentroCostos();

  }
  get centroCostos(): any {
    return this.salidaStore.centroCostos;
  }

  getCentroCostos() {
    this.salidaService.getCentroCostos();
  }

  get historiales(): any[] {
    return this.salidaStore.historial;
  }

  get presupuesto(): any[] {
    return this.salidaStore.salidasMaterial;
  }

  showMaterialesSalida(){
    const data = {
      salidaId: this.salida.id,
    }
    this.salidaService.showMaterialesSalida(data);
  }

  get loading(): boolean {
    return this.materialStore.loading;
  }


  get nuevoCodigo(): string {
    return this.ingresoStore.nuevoCodigo;
  }

  getNuevoCodigo(){
    this.ingresolService.getNuevoCodigo()
  }

  get funcionarioResponsableAutoriza(): any {
    return this.ingresoStore.funcionario_responsable_autoriza;
  }

  getFuncionarioResponsableAutoriza() {
    this.ingresolService.getFuncionarioResponsableAutoriza();
  }

  get sancionNueva(): any[] {
    return this.sancionStore.sancionNueva;
  }
  get cliente(): any[] {
    return this.sancionStore.cliente;
  }
  get funcionarioResponsable(): any {
    return this.ingresoStore.funcionario_responsable;
  }

  get tipo(): any {
    return this.ingresoStore.tipo;
  }
  getFuncionarioResponsable(){
    this.ingresolService.getFuncionarioResponsable();
  }
  getTipo(){
    this.ingresolService.getTipo();
  }

  get medidores(): any {
    return this.salidaStore.medidores;
  }

  round(value: number) {
    return Math.round(value * 100) / 100;
  }

  getMateriales(value:string) {
    this.loading;
    this.materialService.getMateriales(value);
  }

  @Watch('txtSearch')
  search(value: string) {
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getMateriales(value);
      })
    }
  }

  getHistoriaL(){
    const data = {
      salida: this.salida,
      modelo: 'salida',
    };
    this.salidaService.historial(data);
  }

  guardar() {
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar la salida del Presupuesto: <br>
                    ${this.salida.numero_almacen}`
    ).then(res => {
      const data = {salidaId:this.salida.id, salida:this.salida}
      if (res.isConfirmed) {
        this.salidaService.updateSalida(data);
        this.$emit('listar')
        this.getHistoriaL()
      }
    })
  }
  finalizarIngreso() {
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Esta seguro de finalizar la salida? <br>
                    Una vez aceptado se procedera a afectar las cantidades de los materiales del presupuesto<br>
                    Revise bien por favor`
    ).then(res => {
      const data = {presupuesto: this.presupuesto, numero_almacen: this.salida.numero_almacen, codigo: this.salida.codigo}
      if (res.isConfirmed) {
        this.salidaService.finalizarSalida(data);
        this.$emit('listar')
      }
    })
    this.getHistoriaL()
  }

  confirmarKardex() {
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Confirmar salida? <br>`
    ).then(res => {
      const data = {presupuesto: this.presupuesto, numero_almacen: this.salida.numero_almacen, codigo: this.salida.codigo, numero_comprobante: this.salida.numero_comprobante}
      if (res.isConfirmed) {
        this.salidaService.confirmarSalida(data);
        this.$emit('listar')
      }
    })
    this.getHistoriaL()
  }

  devolverMateriales() {
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Esta seguro de devolver los Materiales? <br>
                    Una vez aceptado se procedera a afectar las cantidades de los mismos<br>
                    Revise bien por favor`
    ).then(res => {
      const data = {presupuesto: this.presupuesto, numero_almacen: this.salida.numero_almacen, codigo: this.salida.codigo}
      if (res.isConfirmed) {
        this.salidaService.devolverMateriales(data);
        this.salida.serie = this.salidaStore.newSalida.serie;
        this.$emit('listar')
      }
    })
  }
  updateQuantity(material:object, cantidad_entregada:number){
    const data = {
      material: material,
      ingreso: this.nuevoCodigo,
      cantidad_entregada: cantidad_entregada
    }
    this.salidaService.updateQuantitySalida(data);
  }


  seleccionFuncionario(){
    if(this.selected_funcionario !== null){
      this.medidor= {
        id: this.selected_funcionario.id,
        serie: this.selected_funcionario.serie
      }
    }else
      this.limpiar()

  }

  getMedidores(value:string){
    this.loading
    this.salidaService.getMedidores(value)
  }

  limpiar() {
    this.funcionario = {
      item: '',
      ci: '',
      nombre_completo: ''
    }
  }

  @Watch('txtFuncionario')
  searchFuncionario(value: string) {
    if(value != null && value.length > 5){
      this.$nextTick().then( () => {
        this.getMedidores(value);
      })

      this.medidores_all = this.salidaStore.medidores;

    }
  }


  saveMedidor() {
    Alert.confirm(`Medidor seleccioando correcto?  <br>
                Serie:  ${this.medidor.serie}`
    ).then(res => {
      const data = {medidor: this.medidor, codigo: this.salida.codigo}
      if (res.isConfirmed) {
        this.salidaService.saveMedidor(data);
        this.$emit('listar')
      }
    })
  }

  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde la Salida')
      return false
    }
    this.salidaService.imprimirMedidor(id);

  }


}
